
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dA2FI", function(module, exports) {

$parcel$export(module.exports, "PROJECT_DESC_EN", () => $9e30b5b5de697b16$export$e643ba5917f592d7);
$parcel$export(module.exports, "t", () => $9e30b5b5de697b16$export$625550452a3fa3ec);
$parcel$export(module.exports, "getLang", () => $9e30b5b5de697b16$export$dec8f99c0c14e178);
$parcel$export(module.exports, "applyTranslations", () => $9e30b5b5de697b16$export$562e0893fdbd90ef);
$parcel$export(module.exports, "createSwitcher", () => $9e30b5b5de697b16$export$59ea6d3c1e6d49f7);
$parcel$export(module.exports, "initI18n", () => $9e30b5b5de697b16$export$8464cdd050ea8737);
// ═══════════════════════════════════════════════════════════════
// ██  i18n  ██  Système bilingue FR / EN
// ═══════════════════════════════════════════════════════════════
// Usage :
//   data-i18n="key"              → traduit textContent
//   data-i18n-aria="key"         → traduit aria-label
//   data-i18n-placeholder="key"  → traduit placeholder
//   data-i18n-title="key"        → traduit title attribute
//   data-i18n-content="key"      → traduit content attribute (meta)
// ═══════════════════════════════════════════════════════════════
const $9e30b5b5de697b16$var$TRANSLATIONS = {
    fr: {
        // ── Nav ───────────────────────────────────────────────────
        "nav.playground": "Playground",
        "nav.lang-label": "Langue",
        // ── Hero ──────────────────────────────────────────────────
        "hero.tagline": "Ce que l'\u0153il retient.",
        // ── About ─────────────────────────────────────────────────
        "about.label": "[ \xc0 propos ]",
        "about.aria": "\xc0 propos",
        "about.p1": "Bienvenue\xa0! Je m'appelle Maxime Cordy, Interactive Media Designer bas\xe9 en Valais. Passionn\xe9 par le design graphique, la photographie, la vid\xe9o et le d\xe9veloppement frontend, j'aime cr\xe9er des projets qui allient esth\xe9tique et fonctionnalit\xe9.",
        "about.p2": "De la premi\xe8re id\xe9e jusqu'au r\xe9sultat final, j'accorde une attention particuli\xe8re aux d\xe9tails pour concevoir des exp\xe9riences simples, efficaces et soign\xe9es. Curieux de nature, je vois chaque nouveau projet comme une occasion d'apprendre, d'exp\xe9rimenter et de continuer \xe0 \xe9voluer.",
        "about.p3": "Ayant auparavant obtenu un CFC de boulanger-p\xe2tissier-confiseur, j'ai d\xe9velopp\xe9 un v\xe9ritable esprit d'\xe9quipe ainsi qu'un go\xfbt prononc\xe9 pour la cr\xe9ation et le partage. J'accorde une grande importance \xe0 la collaboration, \xe0 l'\xe9change et \xe0 la qualit\xe9 des relations humaines.",
        "about.cta.contact": "[ Contact ]",
        "about.cta.cv": "[ CV ]",
        "about.cv.download": "[ T\xe9l\xe9charger le CV ]",
        // ── Statement ─────────────────────────────────────────────
        "statement.line1": "J'aime cr\xe9er et partager, apprendre et d\xe9couvrir,",
        "statement.line2": "raconter des histoires et les illustrer.",
        "statement.cta": "[ Travaillons ensemble ]",
        // ── Selected works ────────────────────────────────────────
        "works.label": "[ Travaux s\xe9lectionn\xe9s ]",
        "works.aria": "Travaux s\xe9lectionn\xe9s",
        "works.body": "Au cours de mon apprentissage, j'ai eu l'occasion de concevoir et de r\xe9aliser des projets pour des agences ainsi que des mandats fictifs. Cette s\xe9lection rassemble quelques-unes de mes r\xe9alisations les plus marquantes. N'h\xe9sitez pas \xe0 les d\xe9couvrir dans le Playground.",
        "works.cta": "[ Playground ]",
        // ── Closing note ──────────────────────────────────────────
        "closing.title": "Merci d'\xeatre arriv\xe9 jusqu'ici.",
        "closing.sub": "J'aimerais travailler avec vous,<br>mais vous le voulez vous\xa0?",
        "closing.body1": "Je suis actuellement en recherche de stage ou CDI. Ouvert \xe0 travailler en agence comme pour du priv\xe9.",
        "closing.body2": "Une id\xe9e en t\xeate\xa0? Un produit \xe0 mettre en avant\xa0? Une place \xe0 promouvoir dans votre entreprise\xa0? Je suis d\xe9termin\xe9 \xe0 d\xe9couvrir.",
        "closing.cta.contact": "[Contact]",
        "closing.cta.cv": "[CV]",
        // ── Footer ────────────────────────────────────────────────
        "footer.nav.title": "Navigation",
        "footer.disciplines.title": "Disciplines",
        "footer.disciplines.video": "Vid\xe9o",
        "footer.disciplines.communication": "Communication",
        "footer.contact.title": "Contact",
        "footer.contact.location": "Valais, Suisse",
        "footer.socials.title": "Socials",
        "footer.bar.copy": "\xa9 2026 Maxime Cordy. Tous droits r\xe9serv\xe9s.",
        "footer.bar.credit": "Ce site a \xe9t\xe9 cr\xe9\xe9 en 2026 sur VS Code, avec l'aide de Claude AI",
        "footer.bar.made": "Design & D\xe9veloppement \u2014 Maxime Cordy",
        // ── Panel ─────────────────────────────────────────────────
        "panel.close": "Fermer",
        "panel.prev": "Pr\xe9c\xe9dent",
        "panel.next": "Suivant",
        "panel.category": "Cat\xe9gorie",
        "panel.skills": "Skills",
        "panel.year": "Ann\xe9e",
        "panel.presentation": "Pr\xe9sentation",
        "panel.description": "Description",
        "panel.fallback": "Description \xe0 remplir.",
        // ── Loader ────────────────────────────────────────────────
        "loader.text": "Chargement",
        "loader.aria": "Chargement",
        // ── Playground page ───────────────────────────────────────
        "pg.welcome": "Bienvenue, ici tu d\xe9couvriras toutes mes cr\xe9ations\xa0!",
        "pg.hint": "Clique sur un projet pour en d\xe9couvrir les d\xe9tails.",
        "pg.filter.all": "Tout",
        "pg.filter.video": "Vid\xe9o",
        "pg.filter.photo": "Photo",
        "pg.filter.web": "Web",
        "pg.footer.title": "C'est tout pour l'instant.",
        "pg.footer.sub": "Aidez moi \xe0 agrandir ce portfolio,\xa0",
        "pg.footer.cta": "Travaillons ensemble \u2192",
        "pg.footer.top": "\u2191 Revenir en haut",
        "pg.count.singular": "projet",
        "pg.count.plural": "projets",
        // ── Meta ──────────────────────────────────────────────────
        "meta.title.home": "Maxime Cordy \u2014 Interactive Media Designer",
        "meta.desc.home": "Portfolio de Maxime Cordy, designer interactif passionn\xe9 par l'image, le mouvement et les interfaces. Projets web, vid\xe9o et photo.",
        "meta.title.playground": "Playground \u2014 Maxime Cordy",
        "meta.desc.playground": "Tous les projets de Maxime Cordy \u2014 web, vid\xe9o, photo et design graphique.",
        // ── Project links ─────────────────────────────────────────
        "link.website": "Voir le site",
        "link.figma": "Voir sur Figma",
        "link.youtube": "Voir sur YouTube",
        "link.github": "GitHub"
    },
    en: {
        // ── Nav ───────────────────────────────────────────────────
        "nav.playground": "Playground",
        "nav.lang-label": "Language",
        // ── Hero ──────────────────────────────────────────────────
        "hero.tagline": "What the eye remembers.",
        // ── About ─────────────────────────────────────────────────
        "about.label": "[ About ]",
        "about.aria": "About",
        "about.p1": "Hi\xa0! I'm Maxime Cordy, an Interactive Media Designer based in Valais, Switzerland. With a passion for graphic design, photography, video and front-end development, I love building projects that balance aesthetics and functionality.",
        "about.p2": "From the first idea to the final result, I pay close attention to detail to craft experiences that are clean, efficient and considered. Naturally curious, I see every new project as an opportunity to learn, experiment and keep growing.",
        "about.p3": "I started out as a trained baker-pastry chef, which gave me a strong team spirit and a genuine love of craft and sharing. I place great value on collaboration, open exchange and the quality of human relationships.",
        "about.cta.contact": "[ Contact ]",
        "about.cta.cv": "[ CV ]",
        "about.cv.download": "[ Download CV ]",
        // ── Statement ─────────────────────────────────────────────
        "statement.line1": "I love to create and share, to learn and discover,",
        "statement.line2": "to tell stories and bring them to life.",
        "statement.cta": "[ Let's work together ]",
        // ── Selected works ────────────────────────────────────────
        "works.label": "[ Selected works ]",
        "works.aria": "Selected works",
        "works.body": "Throughout my training I had the opportunity to design and produce projects for agencies as well as fictional briefs. This selection gathers some of my most significant pieces. Feel free to explore more in the Playground.",
        "works.cta": "[ Playground ]",
        // ── Closing note ──────────────────────────────────────────
        "closing.title": "Thanks for making it this far.",
        "closing.sub": "I'd love to work with you \u2014<br>but do you feel the same\xa0?",
        "closing.body1": "I'm currently looking for an internship or a full-time position. Open to working in an agency or directly with a client.",
        "closing.body2": "Got an idea? A product to promote? A role to fill in your team? I'm eager to find out.",
        "closing.cta.contact": "[Contact]",
        "closing.cta.cv": "[CV]",
        // ── Footer ────────────────────────────────────────────────
        "footer.nav.title": "Navigation",
        "footer.disciplines.title": "Disciplines",
        "footer.disciplines.video": "Video",
        "footer.disciplines.communication": "Communication",
        "footer.contact.title": "Contact",
        "footer.contact.location": "Valais, Switzerland",
        "footer.socials.title": "Socials",
        "footer.bar.copy": "\xa9 2026 Maxime Cordy. All rights reserved.",
        "footer.bar.credit": "This site was built in 2026 using VS Code, with the help of Claude AI",
        "footer.bar.made": "Design & Development \u2014 Maxime Cordy",
        // ── Panel ─────────────────────────────────────────────────
        "panel.close": "Close",
        "panel.prev": "Previous",
        "panel.next": "Next",
        "panel.category": "Category",
        "panel.skills": "Skills",
        "panel.year": "Year",
        "panel.presentation": "Overview",
        "panel.description": "Description",
        "panel.fallback": "Description coming soon.",
        // ── Loader ────────────────────────────────────────────────
        "loader.text": "Loading",
        "loader.aria": "Loading",
        // ── Playground page ───────────────────────────────────────
        "pg.welcome": "Welcome \u2014 here you'll find all my work\xa0!",
        "pg.hint": "Click on a project to explore the details.",
        "pg.filter.all": "All",
        "pg.filter.video": "Video",
        "pg.filter.photo": "Photo",
        "pg.filter.web": "Web",
        "pg.footer.title": "That's all for now.",
        "pg.footer.sub": "Help me grow this portfolio,\xa0",
        "pg.footer.cta": "Let's work together \u2192",
        "pg.footer.top": "\u2191 Back to top",
        "pg.count.singular": "project",
        "pg.count.plural": "projects",
        // ── Meta ──────────────────────────────────────────────────
        "meta.title.home": "Maxime Cordy \u2014 Interactive Media Designer",
        "meta.desc.home": "Portfolio of Maxime Cordy, an interactive media designer passionate about image, motion and interfaces. Web, video and photo projects.",
        "meta.title.playground": "Playground \u2014 Maxime Cordy",
        "meta.desc.playground": "All of Maxime Cordy's projects \u2014 web, video, photo and graphic design.",
        // ── Project links ─────────────────────────────────────────
        "link.website": "View website",
        "link.figma": "View on Figma",
        "link.youtube": "View on YouTube",
        "link.github": "GitHub"
    }
};
const $9e30b5b5de697b16$export$e643ba5917f592d7 = {
    "La Galerie des Souvenirs": "La Galerie des Souvenirs was, by far, the most ambitious project I completed during my training. Known as the S6 Project \u2014 the sixth and final semester \u2014 it ran over several months around the shared theme of [Out of Control]. I chose to build an interactive museum website telling the story of artist William Utermohlen and his gradual loss of control as Alzheimer's disease took hold. The site traces his full life: from birth to death, through the different chapters of his career, all the way to the appearance of his first symptoms. I'm extremely proud of this project, which earned me a distinction at the final presentation. I also plan to submit it to Awwwards and SiteInspire in 2027. A physical stand and a poster were also produced for the occasion, to present our work to agencies, private clients and fellow students at an open evening dedicated to the S6 project.",
    "Vitamin Well": "This video holds a special place for me \u2014 both for its quality and for the effort it took to make it happen. The brief was to produce a fictional advertisement for the vitamin drink brand Vitamin Well. The film puts you right in the middle of a run: the effort, the fatigue, the well-earned hydration at the end. The whole piece is wrapped in a cold, overcast atmosphere that reinforces the sense of pushing your limits. Credits: Andr\xe9a Iacoviello, Magnolia Occhipinti, Maxime Cordy",
    "Cin\xe9 Gusto": "Cin\xe9 Gusto was my final major project at the end of my training. For this TPI exam, I had to choose and produce three deliverables to promote a fictional festival blending cinema, gastronomy and transculturalism. I designed a one-page landing page mockup, a digital signage video for the festival's physical locations, and an app icon for a VOD platform bringing together all the films and recipes from the festival. After a marketing analysis, I developed a minimalist art direction to keep things sharp and direct. A halftone treatment on the film posters nods to cinema culture, while saturated-colour food packshots open up the appetite. The project was presented in a 30-minute session in front of industry experts. I'm satisfied with the outcome, though I would have liked more time to refine certain details. Credits: Maxime Cordy",
    "SEUL": "[SEUL] is a fictional short film created from start to finish with four classmates and one actor. The film was selected for the NiFFF (Neuch\xe2tel International Fantastic Film Festival) and follows a man living alone in his chalet, isolated from all human presence, haunted by a strange force that torments him. It was shot in my family's chalet using professional equipment lent by my school, eikon. A single day of shooting was enough thanks to a detailed, complete storyboard. The edit was then divided between the four of us, each responsible for a specific area: sound, music, colour grading, cutting or After Effects work.",
    "Muay Tha\xef": "My friend Nico kindly agreed to let us film a documentary in the gym where he trains Muay Thai. The film follows him through an entire training session, intercut with a face-to-camera interview in which he talks about his connection to the sport, what he loves about it, and invites others to give it a try. Credits: Magnolia Occhipinti, Maxime Cordy, Nicola Cleusix",
    "Sabre": "Sabre is a graphic novel by \xc9ric Feres about a very unusual little tiger. The fictional brief from Eikon asked us to create a storytelling website to promote the book. Together with two colleagues, we reimagined the story to convey both information and emotion to anyone discovering the site \u2014 putting the work firmly in the spotlight. It took a lot of thinking, reading and coding to get there! Credits: Andr\xe9a Iacoviello, Tilio Pezzoli, Maxime Cordy",
    "Harlem": "This site is a bit of an outlier. For an art history project, we had to create an interactive medium presenting five artworks with a common thread. Given tight time constraints, I first designed a landing page mockup in Figma, then decided to use Claude Code and Claude (in Cowork mode) to build an infinite-scroll site made up of several in-depth sections. Credits: Maxime Cordy",
    "Affiches": "Here are three posters I designed over the years. The first was my first professional commission \u2014 for the Juvenalia festival in Fribourg \u2014 which taught me to listen carefully to a client's vision and stay in close contact throughout the creative process. A great experience. The other two were produced as part of my coursework: one for the Les Georges festival, also in Fribourg, and one informational poster about the languages spoken in Switzerland. That last one features a photograph taken by a classmate and myself, showing a young child calling out the different languages through childlike drawings. Credits: Maxime Cordy",
    "Retraite": "For this photo series on the theme of retirement, my grandmother kindly agreed to pose during her favourite sporting activities. The goal was to portray an active retiree and show that a fulfilling retirement can go hand in hand with energy, movement and passion. Credits: Maxime Cordy, Micheline Nanchen",
    "Jaguar": "This was the first video I ever shot at school \u2014 a fictional advertisement promoting two Jaguar Type E cars, roaming different environments across Switzerland, desperately searching for each other before finally meeting at the end. Two days of outdoor shooting with two vintage cars, made with my father and my girlfriend. Credits: Maxime Cordy, Walter Cordy",
    "Bota Bota": "This graphic design project gave me the chance to dive into a full fictional rebrand of the Fribourg Botanical Garden. The idea was to build on the existing identity and bring it into the modern era, with the goal of attracting more visitors. We started by defining an appropriate visual style, then moved on to producing the various mockups. The inspiration for the logo came from looking at the garden's shape on Google Maps \u2014 its form was perfect for creating a mark that links the symbolism of nature (the rings of a tree trunk) with the carefully planned layout of the botanical garden. Credits: Maxime Cordy, Tilio Pezzoli",
    "Is There Anybody Out There ?": 'A music video made for the Pink Floyd song "Is There Anybody Out There?" from the album The Wall. The film follows a tormented young man, trapped inside his own mind, wondering whether there is still anyone out there. Alongside this, footage of nature entirely devoid of human life illustrates a silent outer world, blurring the line between reality, perception and the character\'s possible madness. Credits: Maxime Cordy, Tilio Pezzoli, Andr\xe9a Iacoviello',
    "SABRE Animation": "This animation is the follow-up to the SABRE web project. It picks up the site's visual universe and transforms it into an immersive animated sequence that blends motion design with a strong brand identity. The project explores the narrative possibilities of animation as part of a brand identity system. Credits: Maxime Cordy, Tilio Pezzoli, Andr\xe9a Iacoviello",
    "Croatie": "I love photography \u2014 whether it's nature, studio or portrait work. These shots were taken in Croatia with my Sony A6700 on the island of Komi\u017Ea. The aim was to create a series of images capturing a beach holiday with a nostalgic feel. Credits: Maxime Cordy"
};
// ── Project link label map ────────────────────────────────────
const $9e30b5b5de697b16$var$LINK_LABEL_MAP = {
    fr: {
        "Voir le site": "link.website",
        "Voir sur Figma": "link.figma",
        "Voir sur YouTube": "link.youtube",
        "GitHub": "link.github"
    },
    en: {
        "View website": "link.website",
        "View on Figma": "link.figma",
        "View on YouTube": "link.youtube",
        "GitHub": "link.github"
    }
};
// ── Core ──────────────────────────────────────────────────────
let $9e30b5b5de697b16$var$currentLang = localStorage.getItem("lang") || "fr";
function $9e30b5b5de697b16$export$625550452a3fa3ec(key) {
    return ($9e30b5b5de697b16$var$TRANSLATIONS[$9e30b5b5de697b16$var$currentLang] || $9e30b5b5de697b16$var$TRANSLATIONS.fr)[key] || key;
}
function $9e30b5b5de697b16$export$dec8f99c0c14e178() {
    return $9e30b5b5de697b16$var$currentLang;
}
function $9e30b5b5de697b16$export$a3665b844fbc095d(lang) {
    if (!$9e30b5b5de697b16$var$TRANSLATIONS[lang]) return;
    $9e30b5b5de697b16$var$currentLang = lang;
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
    $9e30b5b5de697b16$export$562e0893fdbd90ef();
    document.dispatchEvent(new CustomEvent("langchange", {
        detail: {
            lang: lang
        }
    }));
}
function $9e30b5b5de697b16$export$562e0893fdbd90ef() {
    const strings = $9e30b5b5de697b16$var$TRANSLATIONS[$9e30b5b5de697b16$var$currentLang] || $9e30b5b5de697b16$var$TRANSLATIONS.fr;
    document.querySelectorAll("[data-i18n]").forEach((el)=>{
        const key = el.dataset.i18n;
        if (strings[key] !== undefined) el.innerHTML = strings[key];
    });
    document.querySelectorAll("[data-i18n-aria]").forEach((el)=>{
        const key = el.dataset.i18nAria;
        if (strings[key] !== undefined) el.setAttribute("aria-label", strings[key]);
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach((el)=>{
        const key = el.dataset.i18nPlaceholder;
        if (strings[key] !== undefined) el.placeholder = strings[key];
    });
    document.querySelectorAll("[data-i18n-title]").forEach((el)=>{
        const key = el.dataset.i18nTitle;
        if (strings[key] !== undefined) el.title = strings[key];
    });
    document.querySelectorAll("[data-i18n-content]").forEach((el)=>{
        const key = el.dataset.i18nContent;
        if (strings[key] !== undefined) el.setAttribute("content", strings[key]);
    });
    // Page title
    const titleKey = document.body.dataset.titleKey;
    if (titleKey && strings[titleKey]) document.title = strings[titleKey];
    // Sync switcher buttons state
    document.querySelectorAll(".lang-btn").forEach((btn)=>{
        btn.classList.toggle("active", btn.dataset.lang === $9e30b5b5de697b16$var$currentLang);
        btn.setAttribute("aria-pressed", btn.dataset.lang === $9e30b5b5de697b16$var$currentLang);
    });
}
function $9e30b5b5de697b16$export$59ea6d3c1e6d49f7() {
    const wrap = document.createElement("div");
    wrap.className = "lang-switcher";
    wrap.setAttribute("aria-label", "Language switcher");
    [
        "fr",
        "en"
    ].forEach((l, i)=>{
        if (i > 0) {
            const sep = document.createElement("span");
            sep.className = "lang-sep";
            sep.textContent = "\xb7";
            sep.setAttribute("aria-hidden", "true");
            wrap.appendChild(sep);
        }
        const btn = document.createElement("button");
        btn.className = "lang-btn";
        btn.dataset.lang = l;
        btn.textContent = l.toUpperCase();
        btn.setAttribute("aria-pressed", l === $9e30b5b5de697b16$var$currentLang);
        btn.addEventListener("click", ()=>$9e30b5b5de697b16$export$a3665b844fbc095d(l));
        if (l === $9e30b5b5de697b16$var$currentLang) btn.classList.add("active");
        wrap.appendChild(btn);
    });
    return wrap;
}
function $9e30b5b5de697b16$export$3eb29e7a957ea458(frLabel) {
    // Find the key by the FR label, then return the current lang label
    const key = $9e30b5b5de697b16$var$LINK_LABEL_MAP.fr[frLabel];
    if (!key) return frLabel;
    return $9e30b5b5de697b16$export$625550452a3fa3ec(key);
}
function $9e30b5b5de697b16$export$8464cdd050ea8737() {
    document.documentElement.lang = $9e30b5b5de697b16$var$currentLang;
    $9e30b5b5de697b16$export$562e0893fdbd90ef();
}

});


//# sourceMappingURL=playground.d315e818.js.map
